import React, { useState, useEffect, useRef } from "react";
import { Table, Spin, Badge, Modal, Select, Input, Form, Button, message, Space, Tooltip, Dropdown } from "antd";
import TextArea from "antd/es/input/TextArea";

import { useNavigate, useParams } from "react-router-dom";
import { FaCirclePlus } from "react-icons/fa6";
import { Timesheetapi } from "../../middleware/interceptor";
import dayjs from 'dayjs';
import { FaRegEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { FaArrowLeft } from 'react-icons/fa';
import { DownOutlined } from '@ant-design/icons';
import { Description } from "@mui/icons-material";
const Ticket = ({ }) => {
  const { clientId } = useParams();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState(clientId);
  const [form] = Form.useForm();
  const [members, setmembers] = useState([{ label: "All", value: "All" }]);
  const [Reqstatus, setReqstatus] = useState([]);

  const [edit, setEdit] = useState(false);

  const [Requirements, setRequirements] = useState([]);

  const [RequirementsList, setRequirementsList] = useState([]);
  const [filterRequirementsList, setFilterRequirementsList] = useState([]);

  const [clientname, setClientname] = useState('');

  const [Clients, setClients] = useState([]);

  const [updatepayload, setupdatepayload] = useState({})

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [workItemType, setWorkItemType] = useState([]);
  const [workItemState, setWorkItemState] = useState([]);

  const [loading, setloading] = useState(false);

  const [isAllowed, setIsAllowed] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [selectedProjectTable, setSelectedProjectTable] = useState('All');
  const [selectedOwner, setSelectedOwner] = useState('All');

  //New
  const [selectedAssignedToMembers, setSelectedAssignedToMembers] = useState([]);


  const handleAssignedToChange = (value) => {
    const allValuesExceptAll = members
      .filter(m => m.value !== 'All')
      .map(m => m.value);

    if (value.includes('All')) {
      setSelectedAssignedToMembers(['All', ...allValuesExceptAll]);
      return;
    }

    setSelectedAssignedToMembers(prev => {
      if (prev.includes('All') && !value.includes('All')) {
        return [];
      }
      return value;
    });
  };

  // useEffect(() => {
  //   const allValuesExceptAll = members
  //     .filter(m => m.value !== 'All')
  //     .map(m => m.value);
  //   setSelectedAssignedToMembers(['All', ...allValuesExceptAll])
  // }, [members]);


  useEffect(() => {
    form.setFieldsValue({ Assigned_To: selectedAssignedToMembers });
  }, [selectedAssignedToMembers]);


  useEffect(() => {
    console.log("Selected", selectedAssignedToMembers);
  }, [selectedAssignedToMembers])


  //New End



  const handleChange = (value) => {
    setSelectedValue(clientId);
    setEdit(false);
    setIsModalVisible(true);
    form.setFieldsValue({
      Item_Priority: 3,
      Status: 1,
      Assigned_To: "All"
    });
    setSelectedAssignedToMembers("All")
    console.log(`selected ${clientId}`);

  };


  useEffect(() => {
    const allowedClientId = localStorage.getItem("allowedClientId");

    if (clientId == allowedClientId) {
      setIsAllowed(true);
      getRequirement();
      getclients();
      getprojectList();
    } else {
      setIsAllowed(false);
    }
  }, []);





  const getprojectList = async () => {

    const response = await Timesheetapi.get(`api/projects/getRequirements?empid=${localStorage.getItem('employee_id')}&Role_Id=${localStorage.getItem('emp_role_id')}&Client_id=${clientId}`)
    const memberOptions = response.data.Result
      .map(Team => ({
        value: Team.Project_id,
        label: Team.projectname,
      }))
    setRequirements(memberOptions);

  }



  const getRequirement = async () => {

    const storedClientIds = JSON.parse(localStorage.getItem('Emp_Assign_client')) || [];

    setloading(true)
    await Timesheetapi.get(`api/projects/getRequirementList?Client_id=${clientId}&&RoleId=${localStorage.getItem("emp_role_id")}&&EmpId=${localStorage.getItem("employee_id")}`).then((response) => {
      const formattedList = response.data.Req_list.map(item => ({
        ...item,
        Start_date: item.Start_date ? dayjs(item.Start_date).format('DD-MM-YYYY') : "-",
        End_Date: item.End_Date ? dayjs(item.End_Date).format('DD-MM-YYYY') : "-",
        Item_Priority_Id: parseInt(item.Item_Priority_Id, 10),
        Severity: parseInt(item.Severity, 10),
        Work_Item_Type: item['Work Item Type']
      }));

      setRawData(formattedList);
      setRequirementsList(formattedList);
      setFilterRequirementsList(formattedList);
      setloading(false)
    });
  }

  const getclients = async () => {
    const ReqStatus = await Timesheetapi.get(`api/Projects/GetRequirementStatus`)
    const filter = ReqStatus.data.Final
      .map(Status => ({
        value: Status.Status_Id,
        label: Status.Status_Name,
      }))
      .filter((item, index, self) =>
        index === self.findIndex(t => t.value === item.value)
      );

    setReqstatus(filter);

    form.setFieldsValue({ Status: 1 });

  }




  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
    form.resetFields();
    setSelectedValue(clientId)
    setSelectedAssignedToMembers([]);
    setmembers([{ label: "All", value: "All" }])
  };

  const navigate = useNavigate();

  // const handleChange1 = (value) => {
  //   let temp = RequirementsList.filter(a => (value.includes(a.)||))
  // };

  // const handleChange2 = (value) => {

  // };


  const handleClientChange = async (value, option) => {
    setClientname(option.label); // Set the label in the state


    await Timesheetapi.get(`api/Projects/GetProjectWiseMember?Projectid=${value}&&Role_id=${localStorage.getItem("emp_role_id")}&&Emp_id=${localStorage.getItem("employee_id")}&&Client_id=${clientId}`).then((res) => {
      console.log(res.data.EmpData)
      const memberOption = res.data.EmpData
        .map(Team => ({
          value: Team.Emp_Id,
          label: Team.Emp_Name,
        }))
        .filter((item, index, self) =>
          index === self.findIndex(t => t.value === item.value)
        );
      setmembers([{ label: "All", value: "All" }, { label: "Assign to Me ", value: parseInt(localStorage.getItem("employee_id"), 10) }, ...memberOption])
      // setmembers(memberOption)
      // setRequirements(memberOption);
      // setRequirements()

    }).catch((err) => {

    })
  };

  const handleSubmit = async (value) => {
    setSelectedProjectTable('All')
    setSelectedOwner('All')
    const formattedDateTime = dayjs().format('DD-MM-YYYY HH:mm:ss');
    const formattedEndDate = dayjs(value.end_date).format('DD-MM-YYYY');

    // Validate Assigned_To
    // const unknownUser = members.find(item => item.value == value.Assigned_To);
    // if (!unknownUser && value.Assigned_To != 1) {

    //   form.setFieldsValue({ Assigned_To: "Unknown User" });
    //   form.setFields([{
    //     name: 'Assigned_To',
    //     errors: ['This User is Not in Project or unknown.'],
    //   }]);
    //   return; // stop submission
    // }
    const cleanedAssignedTo = value.Assigned_To.includes('All')
      ? value.Assigned_To.filter(v => v !== 'All')
      : value.Assigned_To;


    const payload = {
      Item_Id: edit ? updatepayload.Item_Id : 0,
      Req_Id: 0,
      Role_id: localStorage.getItem("emp_role_id"),
      Projectid: value.Project,
      clientid: localStorage.getItem("allowedClientId"),
      itemname: value.Req_title,
      Description: value.description,
      itemtype: "Task",
      assign_by: localStorage.getItem("employee_id"),
      assign_to: cleanedAssignedTo,
      planned_hours: 0,
      item_status: value.Status,
      itempriority: value.Item_Priority,
      Severity: value.Severity,
      item_sdate: formattedDateTime,
      item_edate: formattedDateTime,
    };
    console.log("PAYLOAD", payload)

    try {
      const response = await Timesheetapi.post('api/Projects/addWorkItem', payload);
      if (response.data.status == 1) {
        getRequirement();
        message.success(`Task ${response.data.message}`);
      }
      setIsModalVisible(false);
      form.resetFields();
    } catch (error) {
      message.error("Submission error");
      console.error('Submission error')
    }
  }



  const getProjectHeader = () => {

    if (rawData.length > 0) {
      const projectLists = rawData.reduce((acc, curr) => {
        if (!acc.some(item => item.key === curr.Project_Id)) {
          acc.push(
            {
              label: curr.Project_name,
              key: curr.Project_Id
            });
        }
        return acc;
      }, []);

      const items = [{ label: 'All', key: 'All' }, ...projectLists].map((curr) => {
        const key = curr.key;
        const name = curr.label;

        return {
          key,
          label: (
            <span
              style={{
                width: '100%',
                fontWeight: selectedProjectTable == key ? 'bold' : 'normal',
                color: selectedProjectTable == key ? '#1677ff' : 'black',
              }}
            >
              {name}
            </span>
          ),
        };
      });
      const handleMenuClick = (info) => {
        setSelectedProjectTable(info.key)
      };

      return (
        <Dropdown
          menu={{ items, onClick: handleMenuClick }}
          trigger={['click']}
          className="w-full h-full cursor-pointer"
        >
          <a onClick={e => e.preventDefault()} className="hover:text-blue-500">
            <Space>
              Project Name<DownOutlined />
            </Space>
          </a>
        </Dropdown>
      );
    }
  }


  const getOwnerHeader = () => {

    const items = [
      {
        label: (
          <span style={{
            width: '100%',
            fontWeight: selectedOwner === 'All' ? 'bold' : 'normal',
            color: selectedOwner === 'All' ? '#1677ff' : 'Black',
          }}
          >
            By All
          </span>
        ),
        key: 'All',
      },
      {
        label: (
          <span style={{
            width: '100%',
            fontWeight: selectedOwner == localStorage.getItem('employee_id') ? 'bold' : 'normal',
            color: selectedOwner == localStorage.getItem('employee_id') ? '#1677ff' : 'Black',
          }}
          >
            By Me
          </span>
        ),
        key: localStorage.getItem('employee_id'),
      }
    ];

    const handleMenuClick = (info) => {
      setSelectedOwner(info.key);
      console.log('Selected:', info.key); // <-- Here you get the selected key
    };

    return (
      <Dropdown
        menu={{ items, onClick: handleMenuClick }}
        trigger={['click']}
        className="w-full h-full cursor-pointer"
      >
        <a onClick={e => e.preventDefault()} className="hover:text-blue-500">
          <Space>
            Assigned By<DownOutlined />
          </Space>
        </a>
      </Dropdown>
    );

  }

  useEffect(() => {

    if (rawData.length > 0) {

      let selected = rawData.filter((item) => {
        const projectMatch = selectedProjectTable === 'All' || item.Project_Id == selectedProjectTable;
        const ownerMatch = selectedOwner === 'All' || item.Assigned_By_Id == selectedOwner;
        return projectMatch && ownerMatch;
      });

      console.log("select", selected);
      setFilterRequirementsList(selected);

    }
  }, [selectedProjectTable, selectedOwner, rawData]);

  const columns = [
    {
      title: getProjectHeader(),
      dataIndex: "Project_name",
      key: "Project_name",
    },
    {
      title: "Title",
      dataIndex: "Req_Name",
      key: "Req_Name",
      sorter: (a, b) => a.Req_Name.localeCompare(b.Req_Name),
    },
    {
      title: getOwnerHeader(),
      dataIndex: "Assigned_By",
      key: "Assigned_By",
    },
    {
      title: "Assigned To",
      dataIndex: "Assigned_To",
      key: "Assigned_To",
    },
    {
      title: "State",
      dataIndex: "Item_Status",
      key: "Item_Status",
      render: (state) => {
        const colors = {
          'Rejected': "red",
          'Proposed': "#ff9d00",
          'Completed': 'red',
          'Open': "green",
          "In Progress": "blue"
        };
        return <Badge color={colors[state]} text={state} />;
      },
      sorter: (a, b) => a.Item_Status.localeCompare(b.Item_Status),
    },
    {
      title: "Start Date",
      dataIndex: "Start_date",
      key: "Start_date",
      sorter: (a, b) => new Date(a.Start_date) - new Date(b.Start_date),
    },
    {
      title: "End Date",
      dataIndex: "End_Date",
      key: "End_Date",
      sorter: (a, b) => new Date(a.End_Date) - new Date(b.End_Date),
    },
    {
      title: "Priority",
      dataIndex: "Item_Priority",
      key: "Item_Priority",
      sorter: (a, b) => {
        const priorityOrder = {
          "Low": 1,
          "Medium": 2,
          "High": 3,
          "Critical": 4,
        };

        return priorityOrder[a.Item_Priority] - priorityOrder[b.Item_Priority];
      },
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Space size="middle">
            <Tooltip title="Edit">
              <FaRegEdit
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
            {/* <Tooltip title="Delete">
            <FaTrashAlt
              style={{ color: "red", cursor: "pointer" }}
              onClick={() => handleDelete(record)}
            />
          </Tooltip> */}
          </Space>
        </div>
      ),
    },
  ];


  const handleEdit = async (record) => {

    await Timesheetapi.get(`api/Projects/GetProjectWiseMember?Projectid=${record.Project_Id}&&Role_id=${localStorage.getItem("emp_role_id")}&&Emp_id=${localStorage.getItem("employee_id")}&&Client_id=${clientId}`).then((res) => {

      console.log(res.data.EmpData)
      const memberOption = res.data.EmpData
        .map(Team => ({
          value: Team.Emp_Id,
          label: Team.Emp_Name,
        }))
        .filter((item, index, self) =>
          index === self.findIndex(t => t.value === item.value)
        );
      setmembers([{ label: "All", value: "All" }, { label: "Assign to Me ", value: parseInt(localStorage.getItem("employee_id"), 10) }, ...memberOption])
    })


    console.log("Edit clicked for:", typeof (record.Assigned_To_Id), record.Assigned_To_Id, members);


    setStartDate(record.Start_date == null ? "" : dayjs(record.Start_date, 'DD-MM-YYYY'));
    setEndDate(record.End_Date == null ? "" : dayjs(record.End_Date, 'DD-MM-YYYY'));
    // setSelectedValue(record['Work Item Type'])

    let payload = {}
    setEdit(true);
    setSelectedAssignedToMembers(JSON.parse(record.Assigned_To_Id));
    form.setFieldsValue({
      Client: clientId,
      Project: record.Project_Id,
      Req_title: record.Req_Name,
      description: record.Description,
      Assigned_Hours: record.Estimated_hours,
      Status: parseInt(record.Item_Status_Id, 10),
      start_date: record.Start_date == null ? "" : dayjs(record.Start_date, 'DD-MM-YYYY'),
      end_date: record.End_Date == null ? "-" : dayjs(record.End_Date, 'DD-MM-YYYY'),
      Severity: record.Severity,
      Item_Priority: parseInt(record.Item_Priority_Id, 10),
      Assigned_To: JSON.parse(record.Assigned_To_Id)
    });


    payload = {
      Item_Id: record.Item_Id,
      clientid: clientId,
      Projectid: record.Project_Id,
      Req_name: form.getFieldValue('Req_title'),
      Estimated_hours: form.getFieldValue('Assigned_Hours'),
      itemtype: record['Work Item Type'],
      Start_date: form.getFieldValue(dayjs(record.Start_date, 'DD-MM-YYYY')),
      End_date: form.getFieldValue(dayjs(record.End_Date, 'DD-MM-YYYY')),
      Req_status: form.getFieldValue('Status'),
      created_by: localStorage.getItem("employee_id"),
    }

    setupdatepayload(payload);
    setIsModalVisible(true)
  };

  const handleDelete = (record) => {
    console.log("Delete clicked for:", record);

  };
  const Compare = (data, state, type) => {
    let token = true;
    if (workItemState.length != 0) {
      if (!state.includes(data.Req_Status)) {
        token = false;
      }
    }
    if (workItemType.length != 0) {
      if (!type.includes(data['Work Item Type'])) {
        token = false;
      }
    }
    return token
  }
  useEffect(() => {
    let temp = RequirementsList.filter(a => Compare(a, workItemState, workItemType));
    setFilterRequirementsList(temp)
  }, [workItemState, workItemType])

  const handletitlechange = (e) => {
  }



  return (

    <div className="mt-[2.5rem]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {/* Back Arrow Button */}
          <Tooltip title={"Back"}>
            <button
              onClick={() => window.history.back()}
              className="bg-gray-500 text-[#fff] px-2 py-[5px] rounded-[5px] hover:bg-gray-600 flex items-center gap-1"
            >
              <FaArrowLeft className="text-[14px]" /> {/* Back Arrow Icon */}
            </button>
          </Tooltip>
          <h2 className="text-[16px] font-[600]" style={{ margin: '0' }}>
            {localStorage.getItem("allowedClientId") && localStorage.getItem("allowedClientName")}
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <div>
            <button
              onClick={() => handleChange()}
              className="flex items-center justify-center gap-2 bg-[#2563eb] text-[14px] text-[#fff] px-2 py-[5px] rounded-[5px] w-[150px]"
            >
              <FaCirclePlus className="text-[16px] text-[#fff]" /> Add Task
            </button>
          </div>
        </div>
      </div>
      <div className="relative">
        <div>
          {isModalVisible && (
            <>
              <Modal className="workitem-popup task-popup" title={`${edit ? "Update a" : "Create a"} ${"Task"}`} visible={isModalVisible} onOk={toggleModal} onCancel={toggleModal} footer={null} // Disable default footer buttons
              >
                <div className="bg-white rounded-lg">
                  <Form form={form} onFinish={handleSubmit} layout="vertical">
                    <div style={{ maxHeight: 'calc(100vh - 200px)', overflow: 'hidden auto', marginInline: '-23px', paddingInline: '20px' }}>
                      <div className="grid grid-cols-4 gap-4">
                        <Form.Item
                          label="Project"
                          name="Project"
                          rules={[{ required: true, message: 'Please select a Project' }]}
                        >
                          <Select
                            showSearch
                            optionFilterProp="label"

                            placeholder="Select Project"
                            options={Requirements}
                            onChange={handleClientChange}
                            className="h-10"
                          >
                          </Select>

                        </Form.Item>
                        <div>
                          <Form.Item
                            label="Priority"
                            name="Item_Priority"
                            placeholder="Please select"
                            rules={[{ required: true, message: 'Please select a Priority' }]}
                          >
                            <Select
                              defaultValue={3}
                              options={[
                                { value: 1, label: "Low" },
                                { value: 2, label: "Medium" },
                                { value: 3, label: "High" },
                                { value: 4, label: "Critical" },

                              ]}
                              className="h-10"
                              onChange={(selectedOption) => console.log(selectedOption)} // Handle the selected option
                            />

                          </Form.Item>

                        </div>
                        
                        <div>
                          <Form.Item
                            label="Status"
                            name="Status"

                            placeholder="Please select"
                            rules={[{ required: true, message: 'Please select a Status' }]}
                          >
                            <Select className="h-10"
                              //disabled={true}
                              defaultValue={1}
                              options={Reqstatus}>

                            </Select>

                          </Form.Item>
                        </div>

                        <div>
                          <Form.Item
                            label="Assigned To"
                            name="Assigned_To"
                            placeholder="Please select"
                            rules={[{ required: true, message: 'Please select a value' }]}
                          >
                            <Select
                              mode="multiple"
                              className="h-10"
                              showSearch
                              optionFilterProp="label"
                              options={members}

                              //New
                              defaultValue={"All"}
                              allowClear
                              value={selectedAssignedToMembers}
                              onChange={handleAssignedToChange}
                              placeholder="Please select"
                              maxTagCount={0}
                              tagRender={() => (
                                <div style={{ padding: '3px 8px', borderRadius: '4px' }}>
                                  {selectedAssignedToMembers.includes('All')
                                    ? 'All members'
                                    : `${selectedAssignedToMembers.length} member${selectedAssignedToMembers.length === 1 ? '' : 's'}`}

                                </div>
                              )}
                            >
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="grid grid-cols-1" >
                        <div>
                          <Form.Item
                            label={`Task`}
                            name="Req_title"
                            rules={[{ required: true, message: 'Please enter the title' }]}
                          >
                            <TextArea placeholder="Enter a Title" className="pt-2" style={{ height: '60px' }} onChange={(e) => handletitlechange(e)}></TextArea>
                          </Form.Item>

                        </div>
                        <div>
                          <Form.Item
                            label={`Description`}
                            name="description"
                          >
                            <TextArea placeholder="Enter a Description" className="pt-2" style={{ height: '120px' }} ></TextArea>
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    <Form.Item className="text-right footer-form-item">
                      <Button type="default" onClick={toggleModal} style={{ marginRight: '8px' }}>
                        Cancel
                      </Button>
                      <Button type="primary" htmlType="submit">
                        {edit ? "Update" : "Create"}
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </Modal>


            </>
          )}

        </div>
      </div>
      <div
        className="ticket-table absolute w-[98%] mt-[10px] task-table"
        style={{ maxHeight: "calc(100vh - 140px)", overflow: "auto" }}
      >
        {loading ? (
          <>
            <Spin tip="Loading...">
              <div className="overflow-auto custom-table">
                <Table
                  dataSource={filterRequirementsList}
                  columns={columns}
                  pagination={false}
                />
              </div>
            </Spin>
          </>
        ) : (
          <>
            <Table
              dataSource={filterRequirementsList}
              columns={columns}
              pagination={false}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Ticket;
